module.exports = __webpack_public_path__ + "img/office3_7-8-2021.5e4c2a71.jpg";